/**
 * Device Operations Operation ID Cell - Frontend
 * @description Cell component for displaying operation ID (last 6 characters)
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { DashboardOperation } from '@/types/dashboard.types';

export const DeviceOperationsOperationIdCell: React.FC<{
  info: CellContext<DashboardOperation, string>;
}> = ({ info }) => {
  const operationId = info.getValue();

  return (
    <div className="font-medium text-center text-gray-900">
      {operationId ? `${operationId.slice(-6)}` : '-'}
    </div>
  );
};
